// extracted by mini-css-extract-plugin
export default {"container":"AddRedressInformation_container__Icv3u font-sm-regular"};